import { ProductionOrderProcessDto } from './production-order-process.dto';

export class CheckActiveSessionResponseDto {
  hasActiveSession: boolean;
  userId?: number;
  orderNumber?: string;
  processName?: string;
  processDescription?: string;
  operatorName?: string;
  productionOrderProcess?: ProductionOrderProcessDto;

  constructor(data?: Partial<CheckActiveSessionResponseDto>) {
    this.hasActiveSession = data?.hasActiveSession || false;
    this.userId = data?.userId;
    this.orderNumber = data?.orderNumber;
    this.processName = data?.processName;
    this.processDescription = data?.processDescription;
    this.operatorName = data?.operatorName;
    this.productionOrderProcess = data?.productionOrderProcess;
  }
}
